import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import {
  GridColDef,

} from "@mui/x-data-grid-premium";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import { Box, Paper } from "@mui/material";
import { baseService } from "src/api/core/baseService";
import { useEffect, useState, useRef } from "react";
import ByzDeleteConfirmDialog from "src/components/core-components/mui/ByzDeleteConfirmDialog";
import { useTranslate } from "src/locales/use-locales";
import ByzDataGridToolbar from "src/components/core-components/mui/data-grid/toolbar";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import UploadIcon from "src/components/icons/UploadIcon";

function List() {
  const { t } = useTranslate();

  const [selectedRowId, setSelectedRowId] = useState<number | null>(null);
  const [isolationTypesDataForGrid, setIsolationTypesDataForGrid] = useState<any>([])
  const fileInputRef = useRef<HTMLInputElement>(null);


  const getImageSrc = (base64: string | undefined | null) => {
    if (!base64) return "";

    // Base64 çözümlenmiş ilk birkaç karakter kontrol edilir
    const decodedStart = atob(base64).slice(0, 50).toLowerCase();

    if (decodedStart.includes("<svg")) {
      return `data:image/svg+xml;base64,${base64}`;
    } else if (base64.startsWith("iVBORw0KGgo")) {
      return `data:image/png;base64,${base64}`;
    } else {
      return `data:image/*;base64,${base64}`;
    }
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
  const file = event.target.files?.[0];
  if (!file || !selectedRowId) return;

  const formData = new FormData();
  formData.append("File", file);

  try {
    await baseService.update(`/isolation/api/IsolationType/UpdateIsolationTypeImage/${selectedRowId}`, formData);
    getAllIsolationTypes();
  } catch (err) {
    console.error("Yükleme hatası:", err);
  } finally {
    event.target.value = "";
    setSelectedRowId(null);
  }
};

    const columns: GridColDef[] = [
    {
      field: "UPLOAD_IMAGE",
      headerName: "Resmi Değiştir",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <UploadIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedRowId(params.row.id);
                fileInputRef.current?.click();
              }}
            />
          </>
        );
      }
    },
    {
      field: "picture",
      headerName: "Simge",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
              <img width={30} height={30} src={getImageSrc(params.row.picture ?? params.row.pics_svg)} alt="My SVG" />
            </div>
          </>
        );
      }
    },
    {
      field: "pics_svg",
      headerName: "Varsayılan Simge",
      flex: 1,
      renderCell: (params: any) => {
        return (
          <>
            <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
              <img width={30} height={30} src={getImageSrc(params.row.pics_svg)} alt="My SVG" />
            </div >
          </>
        );
      }
    },
    { field: "name", headerName: "İzolasyon Adı", flex: 1 },
    {
      field: "descrption",
      headerName: "Açıklama",
      flex: 6,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.4,
            width: "100%",
          }}
        >
          {params.row.descrption}
        </Box>
      ),
    },
    {
      field: "IS_ACTIVE",
      headerName: "Aktif",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <ByzMuiCheckBox circular={true} onChange={(event) => {
              const isActive = event.target.checked;
              UpdateIsolationTypeActive(params.row.id, isActive)
            }}
              checked={params.row.is_active === "0" ? false : true} />
          </>
        );
      }
    },
    {
      field: "delete",
      headerName: "Simgeyi Sil",
      flex: 1,
      renderCell: (params) => {
        return (
          <ByzGrdDeleteButton
            onClick={() => {
              handleDeleteRow(params.row?.id?.toString() || "");
            }}
          />
        );
      },
    },
  ];

  const [deleteState, setDeleteState] = useState<any>({
      open: false,
      id: "",
      url: "",
  });

  const handleDeleteRow = (id: string) => {
    setDeleteState({
      open: true,
      id: id,
      url: "/isolation/api/IsolationType/DeleteIsolationTypeImage",
    });
  };

  useEffect(() => {
    getAllIsolationTypes();
  }, []);

  const getAllIsolationTypes = () => {
    baseService.getAll("/isolation/api/IsolationType")
      .then((response) => {
        setIsolationTypesDataForGrid(response);
      })
      .catch((error) => {
        console.error("Error fetching isolation types:", error);
      });
  }


  const UpdateIsolationTypeActive = async (id: number, isActive: boolean) => {
    await baseService.update(`/isolation/api/IsolationType/UpdateIsolationTypeActive/${id}?isActive=${isActive}`, {})
    getAllIsolationTypes();
  }
  const CustomToolbar = () => (
    <ByzDataGridToolbar containerSx={{ pl: 0 }} toolbarSx={{ pl: 0 }} />
  );

  return (
    <>
    <ByzMuiTypography sx={{ fontSize: "20px", fontWeight: 700 }} >
      {t("isolation-type-definitions")}
    </ByzMuiTypography>
    <hr style={{ margin: "10px 0", opacity: 0.5, borderColor: "var(--color-primary)" }} />
    <Paper sx={{ padding: 2 }}>
      <ByzMuiDataGrid
        columns={columns}
        pageSize={10}
        rows={isolationTypesDataForGrid?.data || []}
        customToolbar={CustomToolbar}
        whiteGrid={true}
        getRowHeight={() => "auto"}
        getEstimatedRowHeight={() => 120}
      />
    </Paper>
      <ByzDeleteConfirmDialog
        open={deleteState.open}
        onClose={() => setDeleteState({ ...deleteState, open: false })}
        onSuccess={() => getAllIsolationTypes()}
        patientId={deleteState.id}
        url={deleteState.url}
        title={t("definition-delete")}
        content={t("definition-delete-content")}
      />
      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={(e) => handleFileChange(e)}
      />

    </>
  );
}

export default List;
